import { useEffect, useState } from "react";
import api from "../../api/axios";
import ContactDetailModal from "./ContactDetailModal";

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedContactId, setSelectedContactId] = useState(null);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    const res = await api.get("companyblog/admin/contact-info/");
    setContacts(res.data);
  };

  const openModal = (id) => {
    setSelectedContactId(id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedContactId(null);
    fetchContacts(); 
  };

  return (
    <>
    <div className="card">
      <div className="card-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Full Name</th>
              <th>Contact</th>
              <th>Message</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {contacts.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>

                <td>
                  <strong>{item.name}</strong>
                  <br />
                  <small>
                    {new Date(item.created_at).toLocaleString()}
                  </small>
                </td>

                <td>
                  📞 {item.contact_no}
                  <br />
                  ✉️ {item.email}
                </td>

                <td>{item.message || "-"}</td>

                <td>
                  <span
                    className={`badge ${
                      item.status === "new" ? "bg-primary" : "bg-danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>

                <td>
                  <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => openModal(item.id)}
                    >
                      👁️
                    </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    {showModal && (
        <ContactDetailModal
          contactId={selectedContactId}
          onClose={closeModal}
        />
      )}
      </>
  );
};

export default ContactList;
